// [TODO: native-speaker-review] — AI-translated; verify before launch (Phase 7).
// Tone target: respectful (uses คุณ for "you"), not overly casual, matches the
// quiet cinematic mood of the English copy.

import type { MessageKey } from "../i18n.ts";

const th: Partial<Record<MessageKey, string>> = {
  "nav.browse": "เรียกดู",
  "nav.mylist": "รายการของฉัน",
  "nav.search": "ค้นหา",
  "nav.signin": "เข้าสู่ระบบ",
  "nav.signup": "เริ่มต้น",
  "nav.settings": "การตั้งค่า",
  "nav.logout": "ออกจากระบบ",

  "landing.hero.eyebrow": "สตรีมมิ่งที่ละเมียดละไม",
  "landing.hero.title": "ซีรีส์ที่ไม่ต้องตะโกน",
  "landing.hero.sub": "แคตตาล็อกเล็ก คัดสรรอย่างพิถีพิถัน ไม่มีการเล่นอัตโนมัติรบกวน ดูได้ทุกอุปกรณ์ ยกเลิกได้ทุกเมื่อ",
  "landing.cta.primary": "เริ่มรับชม",
  "landing.cta.secondary": "ดูว่ามีอะไรบ้าง",

  "landing.value.curated.title": "คัดสรร ไม่ใช่ยัดเยียด",
  "landing.value.curated.body": "เราเลือกซีรีส์ที่น้อยกว่า แต่อยู่ในใจคุณนานกว่า อัปเดตทุกสัปดาห์",
  "landing.value.cinematic.title": "การเล่นระดับโรงภาพยนตร์",
  "landing.value.cinematic.body":
    "HLS แบบปรับตัว URL ที่เซ็นชื่อ ข้ามไตเติลได้ ไม่มี DRM กวนใจ ไม่มีกับดักออโต้เพลย์",
  "landing.value.private.title": "ความเป็นส่วนตัวมาก่อน",
  "landing.value.private.body": "ไม่มีการติดตามจนกว่าคุณจะยินยอม เราไม่ขายข้อมูลการรับชมของคุณ ไม่ว่าเมื่อใด",

  "pricing.monthly": "รายเดือน",
  "pricing.yearly": "รายปี",
  "pricing.saveTwoMonths": "ประหยัด 2 เดือน",
  "pricing.cta": "เริ่มสมัครสมาชิก",
  "pricing.note": "ยกเลิกได้ทุกเมื่อจากพอร์ทัลลูกค้า v1 อยู่ในโหมดทดสอบ",

  "footer.about": "เกี่ยวกับเรา",
  "footer.pricing": "ราคา",
  "footer.terms": "ข้อกำหนด",
  "footer.privacy": "ความเป็นส่วนตัว",
  "footer.cookies": "คุกกี้",
  "footer.tagline": "© Krix รับชมอย่างใส่ใจ",

  "auth.signin.title": "เข้าสู่ระบบ",
  "auth.signin.sub": "ยินดีต้อนรับกลับ",
  "auth.signup.title": "สร้างบัญชีของคุณ",
  "auth.signup.sub": "ใช้เวลาแค่สองนาที ไม่ต้องใช้บัตรเครดิตเพื่อเรียกดู",
  "auth.email": "อีเมล",
  "auth.password": "รหัสผ่าน",
  "auth.name": "ชื่อ",
  "auth.google": "ดำเนินการต่อด้วย Google",
  "auth.passkey": "ใช้พาสคีย์",
  "auth.forgot": "ลืมรหัสผ่าน?",
  "auth.haveAccount": "มีบัญชีอยู่แล้ว?",
  "auth.needAccount": "เพิ่งเข้ามาใหม่?",

  "cookies.title": "เราเคารพความเป็นส่วนตัวของคุณ",
  "cookies.body":
    "เราใช้คุกกี้ที่จำเป็นเพื่อให้คุณยังคงล็อกอินอยู่ การวิเคราะห์ปิดอยู่โดยค่าเริ่มต้น — เลือกเปิดเพื่อช่วยเราพัฒนา",
  "cookies.accept": "ยอมรับทั้งหมด",
  "cookies.reject": "เฉพาะที่จำเป็น",
  "cookies.customize": "ปรับแต่ง",

  "error.500.title": "เกิดข้อขัดข้องฝั่งเรา",
  "error.500.body": "เราได้รับแจ้งแล้ว ลองใหม่อีกครั้งในอีกสักครู่ หากยังไม่ได้ ติดต่อ hello@krix.sayantan.cloud",
  "error.404.title": "ไม่พบหน้านี้",
  "error.404.body": "ลิงก์อาจหมดอายุ หรือซีรีส์อาจถูกย้ายแล้ว",
  "error.maintenance.title": "Krix กำลังอัปเดตชั่วคราว",
  "error.maintenance.body": "กลับมาในอีกไม่กี่นาที",
};

export default th;
